import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import siteContent from './content';

// Expose content for Soomer Studio CMS
(window as unknown as { __SOOMER_SITE_CONTENT__: typeof siteContent }).__SOOMER_SITE_CONTENT__ = siteContent;

// Hide scrollbar when ?noscroll=true is in URL (for video recording)
// Also persist to sessionStorage so it works across navigation
if (new URLSearchParams(window.location.search).get('noscroll') === 'true') {
  sessionStorage.setItem('noscroll', 'true');
}
if (sessionStorage.getItem('noscroll') === 'true') {
  document.documentElement.classList.add('noscroll');
}

// Pause hero slider when ?pause_hero=true is in URL (for video recording)
if (new URLSearchParams(window.location.search).get('pause_hero') === 'true') {
  sessionStorage.setItem('pause_hero', 'true');
}
if (sessionStorage.getItem('pause_hero') === 'true') {
  (window as any).__SOOMER_SLIDER_PAUSED__ = true;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
